import { createReducer } from '@lib/plugin-redux-core';
import { AssignmentCreationPageInitialState } from './assignment-creation.state';
import { assignmentCreationHandlers } from './assignment-creation.handler';

export const initialState: AssignmentCreationPageInitialState = {
  error: undefined,
};

export const assignmentCreationReducer = createReducer(initialState, [
  ...assignmentCreationHandlers,
]);
